module.exports = __webpack_public_path__ + "media/images/collapse-9a52a923ceb5983fa0943c1e24d6d35b.gif";